import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full bg-neu-base shadow-neu-inset-sm border border-white/30 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-luvcorp-gold/60 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-gradient-to-r data-[state=checked]:from-luvcorp-gold/90 data-[state=checked]:to-luvcorp-gold-dark data-[state=checked]:shadow-[inset_2px_2px_5px_rgba(0,0,0,0.15)]",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full bg-white shadow-[2px_2px_4px_rgba(0,0,0,0.25),inset_0_1px_0_rgba(255,255,255,0.6)] ring-0 transition-transform data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-1"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
